module.exports = __webpack_public_path__ + "element-icons.ttf?6f0a76321d30f3c8120915e57f7bd77e";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 661
// module chunks = 7